import { fetchPageData } from "../utils/fetch";

export const login = async (authData) => {
  const endpoint = "auth/login";
  const method = "POST";
  const err = "Could not authenticate you!";
  const fetchedData = await fetchPageData(
    endpoint,
    method,
    err,
    null,
    authData
  );
  return fetchedData;
};
